  @for (field of fields; track $index) {
    @if (field.type === 'participants') {
      <h4>{{ 'report.maintanceRound.' + field.name | translate }}</h4>
      @for (item of users(); track $index) {
        <ion-item lines="none">
          <ion-checkbox (ionChange)="onUser($event, item)">{{ item.name }}</ion-checkbox>
        </ion-item>
      }
      <div class="ion-margin-top ion-margin-bottom">
        <ion-button color="light"
          (click)="addUser()">
          {{ 'report.apartmentRound.addUser' | translate }}
        </ion-button>
      </div>
      @for (item of report()[field.name]; track $index; let i = $index) {
        <ion-item lines="none">
          {{ item.name }}
          <ion-button slot="end"
            color="danger"
            (click)="onRemoveUser(i)">
            <ion-icon slot="icon-only"
              name="trash-outline"></ion-icon>
          </ion-button>
        </ion-item>
      } @empty {
        <p>{{ 'report.apartmentRound.noParticipants' | translate }}</p>
      }
    } @else if (field.type === 'input') {
      <ion-item lines="none">
        <ion-input autocapitalize="on"
          [(ngModel)]="report()[field.name]"
          [placeholder]="'report.maintanceRound.' + field.name | translate"
          [type]="field.inputType ? 'number' : 'text'">
        </ion-input>
        <app-speech-to-text (text)="onMic($event, field.name)"></app-speech-to-text>
      </ion-item>
    } @else if (field.type === 'toggle') {
      <ion-item lines="none">
        <ion-toggle [(ngModel)]="report()[field.name]">
          {{ 'report.maintanceRound.' + field.name | translate }}
        </ion-toggle>
      </ion-item>
    } @else if (field.type === 'textarea') {
      <ion-item lines="none">
        <ion-textarea autocapitalize="on"
          [(ngModel)]="report()[field.name]"
          rows="5"
          [placeholder]="'report.maintanceRound.' + field.name | translate">
        </ion-textarea>
        <app-speech-to-text (text)="onMic($event, field.name)"></app-speech-to-text>
      </ion-item>
    } @else if (field.type === 'title') {
      <h3>{{ 'report.maintanceRound.' + field.name | translate }}</h3>
    } @else if (field.type === 'date') {
      <h4>{{ 'report.maintanceRound.' + field.name | translate }}</h4>
      <app-select-day [id]="field.name"
        [color]="'light'"
        [name]="'calendar.title'"
        [value]="report()[field.name]"
        (changed)="onDateChange($event, field.name)"></app-select-day>
    } @else if (field.type === 'images') {
      <h4>{{ 'site.images' | translate }}</h4>
      <app-images [showCamera]="'item.addImage'"
        [images]="report()[field.name]"
        [canDelete]="true"
        (openCamera)="onImage(field.name, $event)"
        (deleted)="onDeleteImage(field.name, $event)"></app-images>
    } @else if (field.type === 'apartments') {
      @for (apartment of report().apartmentItems; track $index) {
        <ion-item lines="none">
          <ion-input autocapitalize="on"
            [(ngModel)]="apartment.name"
            [placeholder]="'report.maintanceRound.apartment' | translate">
          </ion-input>
          <app-speech-to-text (text)="onMic($event, 'name', apartment)"></app-speech-to-text>
        </ion-item>
        <ion-item lines="none">
          <ion-input autocapitalize="on"
            [(ngModel)]="apartment.observations"
            [placeholder]="'report.maintanceRound.apartmentObservation' | translate">
          </ion-input>
          <app-speech-to-text (text)="onMic($event, 'observations', apartment)"></app-speech-to-text>
        </ion-item>
        <h4>{{ 'site.images' | translate }}</h4>
        <app-images [showCamera]="'item.addImage'"
          [images]="apartment.images"
          [canDelete]="true"
          (openCamera)="onImage('images', $event, apartment)"
          (deleted)="onDeleteImage('images', $event, apartment)"></app-images>
      }
      <div class="ion-margin-top ion-margin-bottom">
        <ion-button color="light"
          (click)="addApartment()">
          {{ 'report.maintanceRound.addApartment' | translate }}
        </ion-button>
      </div>
    }
  }